import { EventAuth } from './event-auth.js';

export function anonymousAuth(): EventAuth {
  return { sub: 'anonymous', aud: 'anonymous', iss: 'anonymous' };
}
